import { render, staticRenderFns } from "./IndividualTalentsGrowth.vue?vue&type=template&id=0493431f&scoped=true"
import script from "./IndividualTalentsGrowth.vue?vue&type=script&lang=ts"
export * from "./IndividualTalentsGrowth.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0493431f",
  null
  
)

export default component.exports